var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentralHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.99 21.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a99370;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.76,16.34,21,15.08l-1-.55A10.29,10.29,0,0,0,12.26,1.06V4A7.7,7.7,0,0,1,14,4.69a7.48,7.48,0,0,1,3.49,8.39l-1-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.63,14.2l-1,4.29,1-.55a10.3,10.3,0,0,0,15.56,0l-2.51-1.45a7.5,7.5,0,0,1-10.54,0l1-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.55,3,8.34,0V1.1A10.31,10.31,0,0,0,.56,14.57l2.51-1.45A7.51,7.51,0,0,1,8.34,4V5.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralHub);
export default __webpack_public_path__ + "static/media/central-hub.ac82aae6.svg";
export { ForwardRef as ReactComponent };